import apiAgent from "../../api/apiAgent";
import { useEffect, useState } from "react";
import { PageContainer, PageContent } from "../../components/PageContainer";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { AddButton } from "../../components/Button";
import _ from "lodash";
import { tMsg } from "../../components/ToastNotifications";
import { screenTypes } from "../../utils/slideTemplateAllocation";
import { ListWithPublish } from "../../components/ToggleShowItemComponents/SlideList";
import { SlidesPublishBanner } from "../../components/Publishing";
import parse from "html-react-parser";
import { removeTags } from "../../utils";

const SlidesIndex = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const screenId = _.toNumber(searchParams.get("screenType") || -1);
  const screenType = screenTypes[screenId as keyof typeof screenTypes];
  const modelName = "slides";

  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [refresh, setRefresh] = useState<boolean>(true);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await apiAgent.DataType.getAll(modelName);

      const filteredSlides = response.data.filter(
        (slide: any) => slide.screenType === screenId
      );

      const filteredSlidesWithCustomTitle = filteredSlides.map((slide: any) => {
        const templateName = screenType.options[slide.templateType].label;
        // const caption = removeTags(slide.caption || slide.message || "");
        // const cardTitle = `${templateName}${
        //   slide.caption && " - " + _.truncate(caption, { length: 15 })
        // }`;
        return {
          ...slide,
          cardTitle: templateName,
        };
      });

      setData(filteredSlidesWithCustomTitle);
    } catch (err) {
      console.log(err);
      tMsg.error("Error retrieving data");
      // navigate("/error"); // TODO: put this back after debugging
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (!screenType) navigate("/m/error");
  }, [screenId, refresh]);

  return (
    <PageContainer isLoading={isLoading}>
      <PageContent>
        <BreadCrumbs crumbs={[]} />
        <TitleBar title={screenType?.name || "Unkown Digital Signage ID"}>
          <Link to={`create?screenType=${screenId}`}>
            <AddButton />
          </Link>
        </TitleBar>
        <SlidesPublishBanner />
        <ListWithPublish
          data={data}
          modelName={modelName}
          refreshList={() => setRefresh(!refresh)}
          linkParams={`screenType=${screenId}`}
        />
      </PageContent>
    </PageContainer>
  );
};

export default SlidesIndex;
